import { TextField, Typography } from "@mui/material";
import React from "react";
import { BlockContainer } from "../../../styles/BlockContainer";

interface TextFieldLabeledProps {
  label: React.ReactNode;
  placeholder?: string;
  value?: string | number | readonly string[] | undefined;
  onChange?: React.ChangeEventHandler<HTMLInputElement> | undefined;
  name?: string;
  multiline?: boolean;
  minRows?: string | number;
  InputProps?: any; // Pour permettre l'override venant du parent
  inputProps?: any;
  type?: string;
  autoComplete?: string; // <-- Ajout
  [key: string]: any; // <-- pour permettre {...params} ou d'autres props comme sx, fullWidth, etc.
}

const TextFieldLabeled: React.FC<TextFieldLabeledProps> = ({
  label,
  placeholder = "",
  value,
  onChange,
  name,
  multiline = false,
  minRows,
  InputProps = {},
  inputProps = {},
  type = "text",
  autoComplete, // <-- Ajout
  ...rest
}) => {
  return (
    <BlockContainer>
      <Typography
        variant="body2"
        sx={{ mb: 1, fontWeight: 500, color: "hsl(var(--foreground))" }}
      >
        {label}
      </Typography>
      <TextField
        variant="standard"
        fullWidth
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        name={name}
        size="small"
        multiline={multiline}
        minRows={multiline ? minRows ?? 3 : undefined}
        type={type}
        autoComplete={autoComplete} // <-- Ajout
        InputProps={{
          disableUnderline: true,
          sx: {
            position: "relative",
            display: "flex",
            alignItems: "center",
            border: "1px solid hsl(var(--border))",
            borderRadius: "6px",
            padding: "10px",
            minHeight: "32px",
            bgcolor: "hsl(var(--background))",
            color: "hsl(var(--foreground))",
            ...(multiline ? {} : { height: "36px" }),
          },
          ...InputProps, // fusionne les props externes
        }}
        inputProps={{
          ...inputProps,
          ...(autoComplete !== undefined && { autoComplete }),
        }}
        sx={{
          "& .MuiInputBase-input": {
            fontSize: "14px",
            paddingY: "4px",
            color: "hsl(var(--foreground))",
            "&::placeholder": {
              color: "hsl(var(--muted-foreground))",
              opacity: 1,
              fontSize: "14px",
            },
          },
          "& .MuiInputBase-root:focus-within": {
            borderColor: "hsl(var(--primary))",
            borderWidth: "2px",
          },
        }}
        {...rest} // pour {...params}
      />
    </BlockContainer>
  );
};

export default TextFieldLabeled;
